import BaseUtil from "../../util/BaseUtil";
import BusinessConstants from "../../constant/BusinessConstants";

const type = `@@ActionType/UPDATE@${__filename}`;


const initState = {
    loadingCount: 0,
    loading: false,
    selectedHospitalIds: ["ALL"],
    selectedDistrictIds: ["ALL"],
    openJobTitleDetailDrawerUserType: BusinessConstants.USER_TYPE.EMPLOYEE.code,
    openJobTitleDetailDrawerSpecType: null,
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};

export default viewModel;
